import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

export const Blog = () => {
      const [Blog, setBlog] = useState([]);
      const navigate = useNavigate();
      
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/blog_list"
      );
      setBlog(response.data.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/delete_blog",
        { blog_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success === "1") {
        setBlog((prevUser) =>
          prevUser.filter((user) => user.blog_id !== userId)
        );
        toast.error("Data Deleted Successfully!");
        navigate("/Blog");
      } else {
        toast.error(response.data.error || "Delete failed.");
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };


  return (
    <div>
        <div className="container mt-5">
        <div className="add-btn">
          <Link to="/Blog-add">
            <button className="btn btn-success text-white">
              Add Blog
            </button>
          </Link>
        </div>
        <table className="table table-bordered table-striped">
          <thead className="table-dark">
            <tr>
              <th colSpan="5" className=" text-center bg-white fs-4 text-black">
                Blog Table
              </th>
            </tr>
            <tr>
              <th className="text-white text-center table-custom">Blog Image</th>
              <th className="text-white text-center table-custom">Title</th>
              <th className="text-white text-center table-custom">Description</th>
              <th className="text-white text-center table-custom">Date</th>
              <th className="text-white text-center table-custom">Actions</th>
            </tr>
          </thead>
          <tbody>
            {Blog.map((Data, index) => (
              <tr key={index}>
                <td>
                  <img
                    src={`https://cyberathon.com/silverapartment/${Data.blog_image}`}
                    alt="Banner"
                    style={{ width: "100px", height: "auto" }}
                  />
                </td>
                <td>
                  <strong>{Data.blog_head}</strong>
                </td>
                <td dangerouslySetInnerHTML={{__html: Data.blog_desp}}></td>
                <td>{Data.blog_date}</td>
                <td>
                  <Link to={`/Blog-view/${Data.blog_id}`}>
                    <button className="btn btn-info btn-sm me-1">
                      <i className="fa-regular fa-eye text-white"></i>
                    </button>
                  </Link>
                  <Link to={`/Blog-edit/${Data.blog_id}`}>
                    <button className="btn btn-primary btn-sm me-1">
                      <i className="fa-regular fa-pen-to-square text-white"></i>
                    </button>
                  </Link>
                  <button
                    className="btn btn-danger btn-sm me-1"
                    onClick={() => deleteUser(Data.blog_id)}
                  >
                    <i className="fa-regular fa-trash-can text-white"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export const BlogAdd = () => {
  const users = {
    blog_head: "",
    blog_desp: "",
    blog_date:""
  };
  const [BlogUser, setBlogUser] = useState(users);
  const [BlogImage, setBlogImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const navigate = useNavigate();
   const [editorLoaded, setEditorLoaded] = useState(false);

  // ✅ Load CKEditor dynamically
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.ckeditor.com/4.21.0/standard/ckeditor.js";
    script.async = true;
    script.onload = () => setEditorLoaded(true);
    document.body.appendChild(script);

    return () => {
      if (window.CKEDITOR) {
        Object.keys(window.CKEDITOR.instances).forEach((instance) => {
          window.CKEDITOR.instances[instance].destroy(true);
        });
      }
    };
  }, []);

  // ✅ Initialize CKEditor when loaded
  useEffect(() => {
    if (editorLoaded && document.getElementById("editor") && !window.CKEDITOR.instances.editor) {
      try {
        window.CKEDITOR.replace("editor", { height: 200 });
  
        window.CKEDITOR.instances.editor.on("change", function () {
          setBlogUser((prev) => ({
            ...prev,
            blog_desp: window.CKEDITOR.instances.editor.getData(),
          }));
        });
      } catch (error) {
        console.error("CKEditor initialization error:", error);
      }
    }
  }, [editorLoaded]);
  
  

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setBlogUser({ ...BlogUser, [name]: value });
    console.log(BlogUser);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setBlogImage(file);
    if (file) {
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();

    const editorData = window.CKEDITOR.instances.editor.getData();
    setBlogUser((prev) => ({
      ...prev,
      blog_desp: editorData,
    }));

    const formData = new FormData();
    formData.append("blog_head", BlogUser.blog_head);
    formData.append("blog_desp", editorData);
    formData.append("blog_date", BlogUser.blog_date)

    if (BlogImage) {
      formData.append("blog_image", BlogImage);
    }
    try {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/add_blog",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.success === "1") {
        toast.success("Data Added Successfully!");
        setBlogImage(null);
        setPreviewImage(null);
        navigate("/Blog");
      } else {
        toast.error(response.data.error || "Failed to add Near Point");
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div className="container mt-5">
      <div className="card shadow-sm">
        <div className="card-header table-custom text-white">
          <h4 className="mb-0 text-white text-center">Add Data</h4>
        </div>

        <div className="card-body">
          <form className="row g-3" onSubmit={submitForm}>
            <div className="col-md-6">
              <label htmlFor="image" className="form-label">
                Image
              </label>
              <input
                type="file"
                className="form-control"
                id="blog_image"
                accept="image/*"
                onChange={handleImageChange}
              />
              {previewImage && (
                <img
                  src={previewImage}
                  alt="Preview"
                  className="mt-2"
                  style={{ width: "100px", height: "auto" }}
                />
              )}
            </div>

            <div className="col-md-6">
              <label htmlFor="blog_head" className="form-label">
                Title
              </label>
              <input
                type="text"
                className="form-control"
                id="blog_head"
                name="blog_head"
                placeholder="Enter Title"
                value={BlogUser.blog_head}
                onChange={inputHandler}
              />
            </div>

            <div className="col-md-6">
              <label htmlFor="blog_desp" className="form-label">
                Description
              </label>
             <textarea
                id="editor"
              ></textarea>
            </div>


             <div className="col-md-6">
              <label htmlFor="blog_date" className="form-label">
                Date
              </label>
              <input
                type="date"
                className="form-control"
                id="blog_date"
                name="blog_date"
                placeholder="Enter Date"
                value={BlogUser.blog_date}
                onChange={inputHandler}
              />
            </div>

            <div className="col-12 d-flex justify-content-end">
              <button type="submit" className="btn btn-success" style={{height:"40px"}}>
                Add Blog
              </button>
              <div className="mb-3 ms-2">
                <Link to="/Blog" className="btn btn-secondary">
                  Back
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export const EditBlog = () => {
  const [BlogImage, setBlogImage] = useState(null);
  const [BlogUser, setBlogUser] = useState({
    blog_head: "",
    blog_desp: "",
    blog_date:"",
  });

  const { id } = useParams();
  const navigate = useNavigate();
const [editorLoaded, setEditorLoaded] = useState(false);

    // ✅ Load CKEditor script dynamically
    useEffect(() => {
      const script = document.createElement("script");
      script.src = "https://cdn.ckeditor.com/4.21.0/standard/ckeditor.js";
      script.async = true;
      script.onload = () => setEditorLoaded(true);
      document.body.appendChild(script);
  
      return () => {
        if (window.CKEDITOR) {
          Object.keys(window.CKEDITOR.instances).forEach((instance) => {
            window.CKEDITOR.instances[instance].destroy(true);
          });
        }
      };
    }, []);
  
    // ✅ Fetch existing data from API
    const fetchPedagogyData = async () => {
      try {
       const response = await axios.post(
          `https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_blog_by_id`,
          {
            blog_id: id,
          }
        );
        setBlogUser(response.data.data);

        if (window.CKEDITOR && window.CKEDITOR.instances.editor) {
          window.CKEDITOR.instances.editor.setData(response.data.blog_desp);
        }
      } catch (error) {
        console.error("Error fetching Pedagogy data!", error);
      }
    };
  
    useEffect(() => {
      if (editorLoaded) {
        fetchPedagogyData();
      }
    }, [id, editorLoaded]);
    
    useEffect(() => {
      if (editorLoaded && !window.CKEDITOR.instances.editor) {
        window.CKEDITOR.replace("editor");
      }
    }, [editorLoaded]);
    
   
    useEffect(() => {
      if (editorLoaded && window.CKEDITOR.instances.editor) {
        window.CKEDITOR.instances.editor.setData(BlogUser.blog_desp);
      }
    }, [BlogUser.blog_desp, editorLoaded]);





  const changeHandler = (e) => {
    const { name, value } = e.target;
    setBlogUser((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const submitForm = async (e) => {
    e.preventDefault();

     if (window.CKEDITOR && window.CKEDITOR.instances.editor) {
          BlogUser.blog_desp = window.CKEDITOR.instances.editor.getData();
        }

    const formData = new FormData();
    formData.append("blog_id", id);
    formData.append("blog_head", BlogUser.blog_head);
    formData.append("blog_desp", BlogUser.blog_desp);
    formData.append("blog_date", BlogUser.blog_date)

    if (BlogImage) {
      formData.append("blog_image", BlogImage);
    }

    try {
      const response = await axios.post(
        `https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/update_blog`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.success === "1") {
        toast.info(response.data.message || "Data updated successfully");
        fetchPedagogyData();
        navigate("/Blog");
      } else {
        toast.error(response.data.message || "Failed to update Near Point");
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      role="dialog"
      style={{
        display: "block",
        paddingRight: 18,
        paddingBottom: 50,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
      aria-modal="true"
    >
      <div className="modal-dialog">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            <div className="modal-header table-custom text-white justify-content-center">
              <h5 className="modal-title">Edit Blog</h5>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">
                  Image{" "}
                  <span className="text-danger">
                    (Image must be at least 90x100%)
                  </span>
                </label>
                <input
                  type="file"
                  id="blog_image"
                  className="form-control"
                  onChange={(e) => setBlogImage(e.target.files[0])}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Title</label>
                <textarea
                  rows={4}
                  type="text"
                  value={BlogUser.blog_head}
                  onChange={changeHandler}
                  className="form-control"
                  id="blog_head"
                  name="blog_head"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Descreption</label>
               <textarea
                  id="editor"
                ></textarea>
              </div>
               <div className="mb-3">
                <label className="form-label">Date</label>
                <input
                  type="date"
                  value={BlogUser.blog_date}
                  onChange={changeHandler}
                  className="form-control"
                  id="blog_date"
                  name="blog_date"
                />
              </div>
            </div>

            {/* Modal Footer */}
            <div className="modal-footer">
              <button type="submit" className="btn btn-success">
                Update
              </button>
              <Link to="/Blog">
                <button
                  type="button"
                  className="btn btn-secondary ms-2"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export const ViewBlog = () => {
  const [BlogUser, setBlogUser] = useState({
    blog_image: "",
    blog_head: "",
    blog_desp: "",
    blog_date:""
  });
  const { id } = useParams();

  useEffect(() => {
    const BlogData = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_blog_by_id",
          {
            blog_id: id,
          }
        );
        setBlogUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    BlogData();
  }, [id]);

  return (
    <div className="container mt-5">
       <div className="d-flex justify-content-between">
      <h2 className="mb-4">View Blog</h2>
      <Link to="/Blog" className="btn m-2">
        <button type="button" className="back-btn">Back</button>
      </Link>
</div>
      <div className="card p-3">
        <div>
        <img
          src={`https://cyberathon.com/silverapartment/${BlogUser.blog_image}`}
          alt="Banner"
          className="img-fluid rounded"
          style={{ maxWidth: "400px" }}
        />
      <h3 className="mt-3">{BlogUser.blog_head}</h3>
      <p>{BlogUser.blog_desp}</p>
      <p>{BlogUser.blog_date}</p>
      </div>
      </div>
    </div>
  );
};